import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface WalletTransferState {
  recipient: string;
  amount: string;
  remark: string;
  saveAsBeneficiary: boolean;
  transferStatus: string; 
  password: string;
  otp:string;
}

const initialState: WalletTransferState = {
  recipient: "",
  amount: "",
  remark: "",
  saveAsBeneficiary: false,
  transferStatus: "",
  password: "",
  otp: ""
};

const walletTransferSlice = createSlice({
  name: "walletTransfer",
  initialState,
  reducers: {
    setRecipient(state, action: PayloadAction<string>) {
      state.recipient = action.payload;
    },
    setPassword(state, action: PayloadAction<string>) {
      state.password = action.payload;
    },
    setOtp(state, action: PayloadAction<string>) {
      state.otp = action.payload;
    },
    setAmount(state, action: PayloadAction<string>) {
      state.amount = action.payload;
    },
    setRemark(state, action: PayloadAction<string>) {
      state.remark = action.payload;
    },
    setSaveAsBeneficiary(state, action: PayloadAction<boolean>) {
      state.saveAsBeneficiary = action.payload;
    },
    confirmTransfer(state, action: PayloadAction<any>) {
      // Logic to initiate transfer confirmation
      state.transferStatus = "pending-confirmation";
    },
    verifyPassword(state, action: PayloadAction<string>) {
      // Logic for verifying password
      if (action.payload === "correct-password") {
        state.transferStatus = "password-verified";
      } else {
        state.transferStatus = "password-error";
      }
    },
    verifyOTP(state, action: PayloadAction<string>) {
      // Logic for verifying OTP
      if (action.payload === "123456") {
        state.transferStatus = "otp-verified";
      } else {
        state.transferStatus = "otp-error";
      }
    },
  },
});

export const {
  setOtp,
  setRecipient,
  setAmount,
  setRemark,
  setSaveAsBeneficiary,
  confirmTransfer,
  setPassword,
  verifyPassword,
  verifyOTP,
} = walletTransferSlice.actions;

export default walletTransferSlice.reducer;
